import { AuthService } from './authService';
import { TransitPackagingDto } from '../types/shipmentLine';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://localhost:7141/api/v1';

class TransitPackagingService {
  /**
   * Hent alle emballasjetyper for gjeldende tenant
   */
  async getAll(): Promise<TransitPackagingDto[]> {
    const url = `${API_BASE_URL}/transit-packaging`;
    const response = await AuthService.authenticatedGet(url);

    if (!response.ok) {
      throw new Error(`Failed to fetch transit packaging: ${response.statusText}`);
    }

    return response.json();
  }

  /**
   * Hent en emballasjetype basert på ID
   */
  async getById(transitPackagingId: number): Promise<TransitPackagingDto> {
    const url = `${API_BASE_URL}/transit-packaging/${transitPackagingId}`;
    const response = await AuthService.authenticatedGet(url);

    if (!response.ok) {
      throw new Error(`Failed to fetch transit packaging: ${response.statusText}`);
    }

    return response.json();
  }

  /**
   * Hent standard emballasjetype
   */
  async getDefault(): Promise<TransitPackagingDto | null> {
    const url = `${API_BASE_URL}/transit-packaging/default`;
    const response = await AuthService.authenticatedGet(url);

    if (response.status === 404) {
      return null;
    }

    if (!response.ok) {
      throw new Error(`Failed to fetch default transit packaging: ${response.statusText}`);
    }

    return response.json();
  }
}

export const transitPackagingService = new TransitPackagingService();
